import React, { useContext, useEffect, useState } from "react";
import { Badge, Form, Tab, Tabs } from "react-bootstrap";
import { useTranslation, withTranslation } from "react-i18next";
import { EventContext, LoaderContext, RegulationContext } from "../../../App";
import { EventType, STATUS } from "../../../core/constants/common";
import "./CompanyDashboard.scss";

import 'react-circular-progressbar/dist/styles.css';
import GridLayout from "react-grid-layout";
import 'react-grid-layout/css/styles.css';
import { CgSortAz } from "react-icons/cg";
import 'react-resizable/css/styles.css';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DashboardFilter from "../../../components/AppFilter/DashboardFilter";
import { LS_AUTHORITY_KEY } from "../../../core/constants/common";
import DashGraphConfigService from "../../../core/service/DashGraphConfigService";
import KPIService from "../../../core/service/KPIService";
import DataViewFilter from "../../Common/Dataview/DataViewFilter";
import CompanyGraphCard from "../CompanyDashboardGraph/CompanyGraphCard";
import EmptyGraphDataCard from "../CompanyDashboardGraph/EmptyGraphDataCard";
import KPIGraphCard from "../CompanyDashboardGraph/KPIGraphCard";
import WidgetLibraryPanel from "./WidgetLibraryPanel";
import Utils from "../../../core/utilities/Utils";
import useHasPermission from "../../../core/hooks/useHasPermission";

const DashboardForStandard = ({ t }) => {
  const authority = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
  const lsDat = JSON.parse(localStorage.getItem("authority"));
  const companyId = lsDat.profile.company.id;

  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";
  const { setLoaderDisplay } = useContext(LoaderContext);
  const { goalId } = useParams();

  const year = new Date().getFullYear();
  const [tabkey, setTabKey] = useState(goalId ? 'KPIs' : 'ESG');
  const [annualyear, setAnnualYear] = useState(new Date().getFullYear());
  const [graphProps, setGraphProps] = useState([]);
  const [kpiGraph, setKPIGraph] = useState({ title: '', status: '', graphs: [] });
  const [kpiFilter, setKPIFilter] = useState({ reportingPeriod: `${year}-01-01` });

  const [isESGVisible, setIsESGVisible] = useState(false);
  const [isKPiVisible, setIsKpiVisible] = useState(false);
  const [esgGraphs, setEsgGraphs] = useState();
  const [renderedOn, setRenderedOn] = useState(0);
  const [widgetsPanelDisplay, setWidgetsPanelDisplay] = useState(false);
  const [category, setCategory] = useState('Environmental');
  const [layoutConfig, setLayoutConfig] = useState({});
  const { event, setEvent } = useContext(EventContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { k, i18n } = useTranslation();
  const { hasGoalsAndKPIsViewPermission } = useHasPermission();
  useEffect(() => {
    if (!glbRegulationId) return;

    getGraphProps();
  }, [glbRegulationId]);

  useEffect(() => {
    if (event.event !== EventType.REFRESH_COMPANY_GRAPHS) return;

    // Reset event first
    setEvent({
      event: '',
      data: '',
      status: ''
    });
    getGraphConfig(category);
  }, [event]);

  const getGraphProps = () => {
    DashGraphConfigService.getProps('GRAPH').then(res => {
      if (res.status !== 200) return;

      setGraphProps(res.data.data ?? []);
    }).catch(err => { });
  };

  const getGraphConfig = (catName, t, selectedTab = null) => {
    setLoaderDisplay(true);
    const cat = catName === 'Social'
      ? 'SOCIAL' : catName === 'Governance'
        ? 'GOVERNANCE' : 'ENVIRONMENTAL';
    const emission = selectedTab ? selectedTab === 'GHG' : tabkey === 'GHG';
    DashGraphConfigService.getCompanyGraphs(companyId, glbRegulationId, cat, glbRegulation?.name, t?.name, emission, true)
      .then(res => {
        setLoaderDisplay(false);
        if (res.status !== 200) return;

        const graphs = res.data?.graphs ?? [];
        setEsgGraphs(graphs);
        setLayoutConfig({ 
          id: res.data?.layout?.id, 
          layout: Utils.setupDynamicGraphLayoutConfigFor({ 
            graphs: graphs, 
            lData: res.data?.layout,
            activeLayoutConfig: layoutConfig
          })
        });
        setRenderedOn(Date.now());
      }).catch(err => {
        setLoaderDisplay(false);
      });
  };

  const handleTabChange = (key) => {
    setTabKey(key);
    setKPIGraph({ title: '', status: '', graphs: [] });
    setEsgGraphs([]);
    if (key === 'KPIs' || key === 'Actions') {
      setIsKpiVisible(false);
    };

    if (key === 'ESG') {
      navigate("/company_admin/dashboard");
    }

    setIsKpiVisible(false);
    setIsESGVisible(false);
    setLayoutConfig({});
  };


  const renderTabFilter = () => {
    if (tabkey === 'KPIs' || tabkey === 'Actions') {
      return (
        <div className="Standrad_tabFilterbox">
          <button className="btn btn-secondary SD_tab_filter" onClick={toggleKpi}><CgSortAz /> {t("Filter.label")}</button>
          <div className={isKPiVisible ? '' : 'd-none'}>
            <DataViewFilter view={tabkey === 'KPIs' ? 'DATA_VIEW' : 'ACTIONS_VIEW'}
              dataViewType={'KPI'}
              onApplyFilter={(f) => tabkey === 'KPIs' ? loadKPIGraphs(f) : setKPIFilter(f)}
              viewFilter={true}
              forGraph={true}
              goalId={goalId}
              onLoad={d => {
                if (d.type === 'GOALS' && tabkey === 'KPIs') {
                  loadKPIGraphs(d.filter);
                }
              }}
              onFilterHide={(value) => setIsKpiVisible(value)} />
          </div>
        </div>
      );
    }

    return (
      <div className="Standrad_tabFilterbox">
        <div className="dashboard_filter_section">
          <DashboardFilter
            type={'DASHBOARD'}
            onApplyFilter={(f) => {
              setAnnualYear(f.annualyear);
              setCategory(f.category);
              setEsgGraphs([]);
              getGraphConfig(f.category, f.selectedTopic, null)
            }}
            onFilterHide={(value) => setIsESGVisible(value)}
            onOpenWidgetLib={() => setWidgetsPanelDisplay(true)} />
        </div>
      </div>
    );
  };

  const renderGraphColumn = (type, graph, index) => {
    return (
      <div className="p-2 "
        key={`${type}Graph-${graph.id}-${index}`}
        id={`${type}Graph-${graph.id}-${index}`}>
        <CompanyGraphCard
          key={`${type}Graph-${graph.id}-${index}`}
          renderedOn={renderedOn}
          year={annualyear}
          config={graph} />
      </div>
    );
  };

  const [containerWidth, setContainerWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setContainerWidth(window.innerWidth);
      // console.log("Updated container width:", window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const gridLayoutWidth = containerWidth <= 780 ? containerWidth - 70 : containerWidth - 240;


  const renderESGGraphs = () => {
    return (
      <GridLayout
        className="layout"
        layout={getFilteredLayoutForESGGraphs()}
        cols={16}
        rowHeight={30}
        width={gridLayoutWidth}
        // width={1500}
        onLayoutChange={onLayoutChange}
        onResizeStop={handleResizeStop}
        onDragStop={handleDragStop}
        isResizable={true}
        isDraggable={true}
        draggableHandle=".drag-handle" // This class is used to specify the drag handle defined in CompanyGraphCard
        margin={[20, 20]} // Spacing between grid items
        containerPadding={[5, 10]}>
        {
          esgGraphs?.filter(g => g.type !== 'KPI')?.map((graph, index) => {
            return (
              <div key={`graph-${graph.id}`}>{renderGraphColumn('esg', graph, index)}</div>
            );
          })
        }
        {
          esgGraphs?.filter(g => g.type === 'KPI')?.map((graph, index) => {
            return (
              <div className="ESG_performance_ShortValuesBOx" key={`graph-${graph.id}`}>
                <CompanyGraphCard
                  key={`esgKPIGraph-${graph.id}-${index}`}
                  renderedOn={renderedOn}
                  year={annualyear}
                  config={graph} />
              </div>
            );
          })
        }
      </GridLayout>
    );
  }

  const renderGHGGraphs = () => {
    return (
      <>
        <div className="row mx-0 mt-2">
          {
            esgGraphs?.map((graph, index) => {
              return renderGraphColumn('ghg', graph, index);
            })
          }
          {(!esgGraphs || esgGraphs?.length === 0) && <EmptyGraphDataCard graphConfig={true} />}
        </div>
      </>
    );
  }

  const loadKPIGraphs = (filter) => {
    setLoaderDisplay(true);
    if (!filter.kpiId && !filter.goalId) {
      setKPIGraph({ title: '', status: '', graphs: [] });
      return;
    }

    const period = `${new Date(filter.reportingPeriod).getFullYear()}-01-01`;
    let req;
    if (filter.kpiId > 0) {
      req = KPIService.getGraphByKPI(companyId, period, filter.kpiId);
    } else if (filter.goalId > 0) {
      req = KPIService.getGraphByGoal(companyId, period, filter.goalId);
    }
    req?.then(res => {
      setLoaderDisplay(false);
      if (res.status !== 200) return;
      if (filter.kpiId > 0) {
        setKPIGraph({ ...kpiGraph, graphs: [res.data.data] });
      } else if (filter.goalId > 0) {
        setKPIGraph(res.data.data ?? { graphs: [] });
      }

    }).catch(err => {
      setLoaderDisplay(false);
    });
  };

  const renderKPIGraphs = () => {

    return (
      <>
        <div className="mt-2">
          <h6>{kpiGraph.title}</h6>
          {
            kpiGraph.status &&
            <Badge bg={kpiGraph.status === 'COMPLETED' ? 'badge-Published' : kpiGraph.status === 'IN_PROGRESS' ? 'badge-Inprogress' : 'badge-Draft'}>
              {STATUS[kpiGraph.status]}
            </Badge>
          }
        </div>
        <div className="row m-0 my-1">
          {
            kpiGraph?.graphs?.map((graph, index) => {
              return (
                <div className="col-lg-6 col-md-6 p-2 ESG_GraphView_col "
                  key={`kpiGraph-${index}`}
                  id={`kpiGraph-${index}`}>
                  <KPIGraphCard graphData={graph} />
                </div>
              );
            })
          }
          {kpiGraph?.graphs?.length == 0 && <EmptyGraphDataCard graphConfig={true} />}
        </div>
      </>
    );
  };

  const toggleKpi = () => {
    setIsKpiVisible(!isKPiVisible);
  };

  const onLayoutChange = (newLayout) => {
  };

  const saveLayout = (updatedLayout) => {
    const layout = [];
    updatedLayout?.forEach(l => {
      layout.push({
        i: +(l.i.split('-')[1]),
        x: l.x,
        y: l.y,
        w: l.w,
        h: l.h,
        minW: l.minW,
        minH: l.minH
      });
    });
    // Add other category layouts
    layoutConfig?.layout?.forEach(l => {
      const id = +(l.i.split('-')[1]);
      if (layout.findIndex(o => o.i === id) < 0) {
        layout.push({
          i: +(l.i.split('-')[1]),
          x: l.x,
          y: l.y,
          w: l.w,
          h: l.h,
          minW: l.minW,
          minH: l.minH
        });
      }
    });
    const lConfig = {
      ...layoutConfig,
      layout: layout
    };
    setLoaderDisplay(true);
    DashGraphConfigService.saveGraphLayout(glbRegulationId, lConfig).then(res => {
      setLoaderDisplay(false);
      if (res.status !== 200 && res.status !== 201) return;


    }).catch(err => {
      setLoaderDisplay(false);
    });
  };

  const handleResizeStop = (layout, oldItem, newItem) => {
    saveLayout(layout);
  };

  const handleDragStop = (layout, oldItem, newItem) => {
    saveLayout(layout);
  };

  const renderNavigateViewButtons = () => {
    return (
      <div className="KPIToggleBtn">
        <div className="ToggleBtn">
          <Form.Check
            className="toggle-switch"
            inline
            label="Status"
            name="assessType"
            type="radio"
            id="statusView"
            onChange={(e) => toggleViews(e.target.id)}
          />
          <Form.Check
            className="toggle-switch"
            inline
            label="Analytical"
            name="assessType"
            type="radio"
            id="analyticalView"
            checked
          />
          <Form.Check
            className="toggle-switch"
            inline
            label="Data"
            name="assessType"
            type="radio"
            id="dataView"
            onChange={(e) => toggleViews(e.target.id)}
          />
        </div>
      </div>
    );
  };

  const toggleViews = (view) => {
    if (view === 'dataView') {
      navigate(`/company_admin/kpidataview/goal/${goalId}`, { state: { goal: location.state.goal } });
    } else if (view === 'statusView') {
      navigate(`/company_admin/kpistatusview/goal/${goalId}`, { state: { goal: location.state.goal } });
    }
  }

  const getFilteredLayoutForESGGraphs = () => {
    const graphIds = [];
    esgGraphs?.forEach(g => graphIds.push(g.id));
    return layoutConfig?.layout?.filter(l => graphIds.indexOf(+(l.i.split('-')[1])) >= 0);
  };
  
  return (
    <div className="Standard_Dashboard_box px-2">
      {tabkey === 'KPIs' && goalId && renderNavigateViewButtons()}
      <div className={`p-0 Standard_Dashboard_box_tab col-12`}>
        <Tabs defaultActiveKey={tabkey}
          id="justify-tab-example"
          className="mb-0"
          onSelect={(k) => handleTabChange(k)}>
          {renderTabFilter()}
          <Tab eventKey="ESG" title={t("ESGPerformance.label")} className="ESGPerformance_tab">
            {tabkey === 'ESG' && renderESGGraphs()}
          </Tab>
          {hasGoalsAndKPIsViewPermission() && (
            <Tab eventKey="KPIs" title={t("GoalsandKPIs.label")} className="GoalsandKPIs_tab">
              {tabkey === 'KPIs' && renderKPIGraphs()}
            </Tab>
          )}
          {/* <Tab eventKey="Actions" title={t("Actions.label")}>
            {tabkey === 'Actions' && <div className="mt-2"><KPIActionsGraph filter={kpiFilter} /></div>}
          </Tab> */}
          {/* <Tab eventKey="GHG" title={t("GHGEmissions.label")}>
            {tabkey === 'GHG' && renderGHGGraphs()}
          </Tab> */}
        </Tabs>
        {
          widgetsPanelDisplay &&
          <div className="AddWidgetsDashboard">
            <WidgetLibraryPanel
              category={category}
              renderedOn={renderedOn}
              onHide={() => setWidgetsPanelDisplay(false)}
              onAdd={() => getGraphConfig(category)} />
          </div>
        }
      </div>

    </div>
  );
};
export default withTranslation()(DashboardForStandard);
